import {Injectable} from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/auth';
import {AngularFireAuth} from '@angular/fire/auth';
import {from, Observable, of} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirebaseAuthService {
  constructor(private afAuth: AngularFireAuth) { }

  createUserWithEmailAndPassword(data): Observable<any> {

    return from(this.afAuth.createUserWithEmailAndPassword(data.email, data.password));
  }

  fetchFirebaseData(data) {
    let provider;

    if (data.provider === 'GOOGLE') {
      provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope('profile');
      provider.addScope('email');
    } else if (data.provider === 'FACEBOOK') {
      provider = new firebase.auth.FacebookAuthProvider();
    } else if (data.provider === 'EMAIL') {
      return from(
        this.afAuth.signInWithEmailAndPassword(data.email, data.password),
      );
    } else if (data.provider === 'APPLE') {
      provider = new firebase.auth.OAuthProvider('apple.com');
      provider.addScope('email');
      provider.addScope('name');
    }

    if (provider) {
      return from(
        this.afAuth.signInWithPopup(provider),
      );
    }

    return of(null);
  }
}
